<canvas #canvasDocument class="canvas"></canvas>
<footer class="footer">
  <div class="footer__fps">{{ fps }}</div>
  <div class="footer__button-group">
    <button class="footer__button order" (tap)="refreshOrderLayers()">Layer order</button>
    <p class="footer__label">Antialiasing:</p>
    <button
      class="footer__button"
      *ngFor="let samples of samplesArray"
      [class.is-active]="selectedSamples(samples)"
      (tap)="setActiveSamples(samples)"
    >
      {{samples}}
    </button>
  </div>
</footer>
